import { filteredUserRoles } from 'constants/userRoles';
import { FormType, IForm, IFormView } from 'shared/Form/types';

export const createFields: IForm = {
  name: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Имя',
    extraKey: 'name',
  },
  email: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Email',
    extraKey: 'email',
    onSubmitRegexp:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  password: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Пароль',
    extraKey: 'password',
    minLength: 6,
    inputType: 'password',
    equalRef: 'rePassword',
  },
  rePassword: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Повторите пароль',
    minLength: 6,
    equalRef: 'password',
    inputType: 'password',
  },
  isActive: {
    type: FormType.SWITCH,
    value: true,
    label: 'Статус пользователя',
    extraKey: 'isActive',
  },
  role: {
    type: FormType.SELECT,
    value: '',
    label: 'Роль',
    extraKey: 'role',
    options: filteredUserRoles(),
    required: true,
  },
};

export const updateFields: IForm = {
  name: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Имя',
    extraKey: 'name',
  },
  email: {
    type: FormType.TEXT,
    required: true,
    value: '',
    label: 'Email',
    extraKey: 'email',
    onSubmitRegexp:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  password: {
    type: FormType.TEXT,
    value: '',
    label: 'Пароль',
    extraKey: 'password',
    minLength: 6,
    inputType: 'password',
    equalRef: 'rePassword',
  },
  rePassword: {
    type: FormType.TEXT,
    value: '',
    label: 'Повторите пароль',
    minLength: 6,
    equalRef: 'password',
    inputType: 'password',
  },
  isActive: {
    type: FormType.SWITCH,
    value: true,
    label: 'Статус пользователя',
    extraKey: 'isActive',
  },
  role: {
    type: FormType.SELECT,
    value: '',
    label: 'Роль',
    extraKey: 'role',
    options: filteredUserRoles(),
    required: true,
  },
};

export const view: IFormView = [
  {
    block: [
      ['name', 'email'],
      ['password', 'rePassword'],
      ['role'],
      ['isActive'],
    ],
  },
];
